import React, { useState } from 'react';
import Stack from '@mui/material/Stack';
import NotificationsRoundedIcon from '@mui/icons-material/NotificationsRounded';
import NavbarBreadcrumbs from './NavbarBreadcrumbs';
import MenuButton from './MenuButton';
import ColorModeIconDropdown from '../shared-theme/ColorModeIconDropdown';
import Search from './Search';
import Popover from '@mui/material/Popover';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import { useConfig } from './ConfigContext';

export default function Header() {
  const { changes, saveConfig } = useConfig();
  const hasUnsaved = Object.keys(changes).length > 0;
  const [anchorEl, setAnchorEl] = useState(null);

  // Label-Mapping für lesbare Feldnamen
  const labelMap = {
    temperatur_tag: 'Temperatur Tag',
    temperatur_nacht: 'Temperatur Nacht',
    luftfeuchte_tag: 'Luftfeuchte Tag',
    luftfeuchte_nacht: 'Luftfeuchte Nacht',
    abluft_max_intensity: 'Abluft Intensität',
    abweichung_luftfeuchte: 'Abweichung Luftfeuchte',
    max_light: 'Max. Lichtintensität',
    dauer: 'Dauer',
    sun_rise: 'Sonnenaufgang',
    sun_set: 'Sonnenuntergang',
  };

  const handleOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSave = () => {
    saveConfig();
    handleClose();
  };

  return (
    <>
      <Stack
        direction="row"
        sx={{
          display: { xs: 'none', md: 'flex' },
          width: '100%',
          alignItems: { xs: 'flex-start', md: 'center' },
          justifyContent: 'space-between',
          maxWidth: { sm: '100%', md: '1700px' },
          pt: 1.5,
        }}
        spacing={2}
      >
        <NavbarBreadcrumbs />
        <Stack direction="row" sx={{ gap: 1 }}>
          <Search />
          <MenuButton
            showBadge={hasUnsaved}
            aria-label="Open notifications"
            onClick={handleOpen}
          >
            <NotificationsRoundedIcon />
          </MenuButton>
          <ColorModeIconDropdown />
        </Stack>
      </Stack>

      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <Box sx={{ width: 300, p: 2 }}>
          <List sx={{ p: 0 }}>
            {hasUnsaved ? (
              Object.entries(changes).map(([key, value]) => (
                <ListItem key={key} disablePadding>
                  <ListItemText
                    primary={`${labelMap[key] || key} geändert auf ${value}`}
                  />
                </ListItem>
              ))
            ) : (
              <ListItem disablePadding>
                <ListItemText primary="Keine neuen Benachrichtigungen" />
              </ListItem>
            )}
          </List>
          {hasUnsaved && (
            <Button
              fullWidth
              variant="contained"
              color="primary"
              onClick={handleSave}
              sx={{ mt: 2 }}
            >
              Alle Änderungen speichern
            </Button>
          )}
        </Box>
      </Popover>
    </>
  );
}
